import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const SSOService = {
    getSSODetails
  };

  function getSSODetails(sso,sig) {
    let sso_login_url=ENV.sso_login_url+'?sso='+sso+'&sig='+sig;
    return axiosInterceptors
    .post(sso_login_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
  }
   